import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_SHARE_VISUALS = defineFcm('supporter_share_visuals')
	.asBoolean()
	.withDefault(false)
	.toConfig();
